import {
  REQUEST_AUTH,
  AUTH_USERID,
  AUTH_USER,
  UNAUTH_USER,
  AUTH_ERROR,
  FETCH_MESSAGE,
  AUTH_USER_PERMISSIONS
} from '../actions/type';

const INITIAL_STATE = {
  authenticated: false,
  isLoading: false,
  error: null,
  userType: null,
  userPermissions: null,
  BaseUser_id: null
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_AUTH:
      return {...state, error: null, isLoading: true }
    case AUTH_USERID:
      return {...state, BaseUser_id: action.payload };
    case AUTH_USER:
      return {...state, error: null, isLoading: false, authenticated: true, userType: action.payload };
    case AUTH_USER_PERMISSIONS:
      return {...state, authenticated: true, userPermissions: action.payload };
    case UNAUTH_USER:
      return {...state, error: null, isLoading: false, authenticated: false };
    case AUTH_ERROR:
      return {...state, error: action.payload, isLoading: false };
    case FETCH_MESSAGE:
      return {...state, message: action.payload.data.message };
  }
  return state;
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/auth_reducer.js